// extracted by mini-css-extract-plugin
export default {"commentFormPlaceholder":"rPt7t","commentFormWrapper":"_8DxRi","commentForm":"vICFv"};